module.exports = __webpack_public_path__ + "img/Remove.7bbce822.svg";